import React, { forwardRef } from 'react';
import { formatCurrency } from '@utils/formatters';
import styles from './TransactionItem.module.css';

export interface ITransactionItemProps extends React.HTMLAttributes<HTMLDivElement> {
  description: string;
  amount: number;
  isDebit: boolean;
  date?: string;
  time?: string;
  showRoiBadge?: boolean;
  variant?: 'list' | 'card';
  animationDelay?: number;
}

const TransactionItem = forwardRef<HTMLDivElement, ITransactionItemProps>(
  (
    {
      description,
      amount,
      isDebit,
      date,
      time,
      showRoiBadge = false,
      variant = 'list',
      animationDelay,
      className,
      style,
      ...rest
    },
    ref,
  ) => {
    const itemClassName = [styles.item, styles[variant], className || ''].filter(Boolean).join(' ');

    const animationStyle: React.CSSProperties | undefined =
      variant === 'card' && animationDelay !== undefined
        ? { animationDelay: `${animationDelay}ms` }
        : undefined;
    const mergedStyle = animationStyle || style ? { ...animationStyle, ...style } : undefined;

    const timeLabel = date && time ? `${date} - ${time}` : date || time;

    return (
      <div ref={ref} className={itemClassName} style={mergedStyle} {...rest}>
        <div className={styles.details}>
          <span className={styles.description}>{description}</span>
          {timeLabel && (
            <span className={styles.time}>
              {timeLabel}
              {showRoiBadge && <span className={styles.roiBadge}>ROI</span>}
            </span>
          )}
        </div>
        <div className={styles.amountWrapper}>
          <span className={styles.accent}>{isDebit ? '-' : '+'}</span>
          <span className={styles.amount}>{formatCurrency(amount)}</span>
        </div>
      </div>
    );
  },
);

TransactionItem.displayName = 'TransactionItem';

export default TransactionItem;
